"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const client_auth_1 = require("@deliverr/client-auth");
const core_auth_1 = require("@deliverr/core-auth");
class ClaimClient extends base_client_1.ApiClient {
    constructor(config) {
        const CLAIMS_SERVICE_URL = config.baseURL || process.env.CLAIMS_SERVICE_URL;
        if (!CLAIMS_SERVICE_URL) {
            throw new Error("The CLAIMS_SERVICE_URL environment variable is not set.");
        }
        let apiClientConfig = {
            authEngine: core_auth_1.AuthEngine.COGNITO,
        };
        if (config.authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            const tokenHandler = new client_auth_1.OAuthClientTokenBuilder(config);
            apiClientConfig = {
                authEngine: core_auth_1.AuthEngine.COGNITO_INTERNAL,
                tokenRefreshFn: tokenHandler.getTokenFn(),
            };
        }
        apiClientConfig = {
            ...config,
            ...apiClientConfig,
        };
        super({
            ...apiClientConfig,
            baseURL: `${CLAIMS_SERVICE_URL}`,
        });
    }
    async getClaimByClaimId(claimId) {
        return this.get(`/claims/${claimId}`);
    }
    async getClaimsByFilter(filter) {
        return this.get("/claims/claims", filter);
    }
    async createClaim(createClaimInput) {
        return this.post("/v2/claims", createClaimInput);
    }
    async createLegacyClaim(claim) {
        return this.post("/claims/create", claim);
    }
    async indexFile(contentType, title, sellerId) {
        return this.post("/claims/index-file", {
            contentType,
            title,
            sellerId,
        });
    }
    async approveClaim(claimId, by) {
        return this.put("/claims/approve", {
            claimId,
            by,
        });
    }
    async rejectClaim(claimId, by, rejectionReason) {
        return this.put("/claims/reject", {
            claimId,
            by,
            rejectionReason,
        });
    }
    async retractClaim(claimId, by, retractionReason) {
        return this.put("/claims/retract", {
            claimId,
            by,
            retractionReason,
        });
    }
    async uploadUrl(contentType, title, sellerId, index) {
        const queryParams = index ? { index } : {};
        return this.post("/claims/upload-url", queryParams, { contentType, title, sellerId });
    }
    createClaimAppeal(claimId, claimAppealRequest) {
        return this.post(`/claims/${claimId}/appeal`, claimAppealRequest);
    }
}
exports.ClaimClient = ClaimClient;
//# sourceMappingURL=ClaimClient.js.map